export enum POSTCODE_PROVIDER_ERROR {
    NETWORK_ERROR = -1,
    PARSE_ERROR = -2,
    ABORT_ERROR = -3
}
